import { makeStyles } from '@material-ui/core/styles';
import { InputVariants } from './InternationalPhoneInput';

const styles = (theme) => ({
  phoneInputWrap: {
    height: ({ variant }) => (variant === InputVariants.SIGNUP ? 'auto' : '45px'),
    lineHeight: ({ variant }) => (variant === InputVariants.SIGNUP ? '42px' : '45px'),
    borderRadius: ({ variant }) => (variant === InputVariants.SIGNUP ? 0 : '70px'),
    background: ({ variant }) => (variant === InputVariants.SIGNUP ? 'none' : '#f4f4f4'),
    margin: ({ variant }) => (variant === InputVariants.SIGNUP ? '16px 0 8px 0' : 0),
  },
  phoneInputAddon: {
    padding: '0 16px',
    width: 90,
    height: 45,
    fontSize: 18,
    textAlign: 'center',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    background: ({ variant }) => (variant === InputVariants.SIGNUP ? '#ffffff' : 'none'),
  },
  inputContainer: {
    padding: ({ variant }) => (variant === InputVariants.SIGNUP ? 0 : '0 11px'),
    flex: 1,
    minWidth: 0,
  },
  nationOptionPanel: {
    position: 'absolute',
    top: 55,
    left: 0,
    zIndex: 2,
    width: '100%',
    borderRadius: '20px',
    background: '#f4f4f4',
  },
  countryOption: {
    padding: '10px 0',
  },
  phonePrefix: {
    width: 60,
    textAlign: 'right',
  },
  nationName: {
    flex: 1,
    marginLeft: 8,
  },
  helperText: {
    fontSize: 18,
    marginTop: 8,
  },
  primary: {
    color: theme.palette.primary.main,
  },
  light: {
    color: '#ffffff',
  },
  outlinedChowbusInput: {
    borderLeft: 0,
  },
  outlinedChowbusInputContainer: {
    paddingLeft: 0,
  },
});

export default makeStyles(styles);
